/**
 * @file steps
 * @author (gaojie15@baidu.com)
 */
import React from 'react';
import PropTypes from 'prop-types';
export default function steps(props) {
    const cur = props.current;
    return <div className="x-steps">
        <span>
            {cur === '1'
                ? <img src={require('../../asset/img/attest/intro/step1.png')} alt=""/>
                : <img src={require('../../asset/img/attest/intro/stepcur.png')} alt=""/>
            }
            企业资质与号码
        </span>
        <span className={cur === '1' ? 'cur' : ''}>
            {cur === '1'
                ? <img src={require('../../asset/img/attest/intro/step2.png')} alt=""/>
                : <img src={require('../../asset/img/attest/intro/step2cur.png')} alt=""/>
            }
            后台审核
        </span>
    </div>;
}
steps.propTypes = {
    current: PropTypes.string
};